import { contentBlock } from "@omni/ui/components/Search/SearchResults/components/ResultList/components/contentBlock.style";
import { contentResultListHit } from "@omni/ui/components/Search/SearchResults/components/ResultList/components/contentResultListHit.style";
import { tv } from "tailwind-variants";

const base = tv({
    base: []
});

export const resultList = Object.assign(base, {
    contentBlock: contentBlock,
    contentResultListHit: contentResultListHit
});
